// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"300":"cc88ab10","362":"0f3b74bd","771":"833e2494"}[chunkId] + ".chunk.css";
};